module.exports = "pegasus_template/assets/circleline-linkedin.png";